import { render, staticRenderFns } from "./PageRoutes.vue?vue&type=template&id=c1635242&"
import script from "./PageRoutes.vue?vue&type=script&lang=ts&"
export * from "./PageRoutes.vue?vue&type=script&lang=ts&"
import style0 from "./PageRoutes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VAutocomplete,VDataTable})
